import { jsx as _jsx } from "react/jsx-runtime";
import { bemClassBuilder } from '@vista-digital/bem-class-builder';
import { observer } from 'mobx-react';
import { useContext } from 'react';
import { useOccConfig } from '../../../context/occ/hooks/use-occ-config';
import { AutoCompleteType } from '../../../subcomponents/form/auto-complete-type';
import { FieldSkeleton } from '../../../subcomponents/form/field/field/subcomponents/skeleton';
import { InputField } from '../../../subcomponents/form/field/input/input-field';
import { getFieldClassName, getFieldId } from '../../../subcomponents/form/field/utils/field-attribute-utils';
import { getHelpTextId } from '../../../subcomponents/form/help-text/utils/get-help-text-id';
import { InvalidFieldNameError } from '../../../types/invalid-field-name-error';
import { withComponentWrapper } from '../../../utils/with-component-wrapper';
import { TicketRedemptionCodeFormActionType } from '../ticket-redemption-code-form/types/action-type';
import { TicketRedemptionCodeFormContextInstance } from '../ticket-redemption-code-form/types/context';
import { TicketRedemptionCodeFormFieldPin } from './subcomponents/pin';
import { TicketRedemptionCodeFormFieldType } from './subcomponents/type';
import { TicketRedemptionCodeFormFieldName } from './types/name';
import { defaultTicketRedemptionCodeFormFieldPropsProvider, ticketRedemptionCodeFormFieldPropsValidator } from './types/props';
const b = bemClassBuilder('v-ticket-redemption-code-form-field');
const TicketRedemptionCodeFormField = observer(props => {
    const { enableSkeletonLoadingIndicators } = useOccConfig();
    const { name, displayText } = props;
    const { onChange, formData, validator, validationResult, validationConfig, dispatch, config, loading, disabled } = useContext(TicketRedemptionCodeFormContextInstance);
    const fieldId = getFieldId(b, name);
    const handleSetHelpText = (error) => {
        dispatch({
            type: TicketRedemptionCodeFormActionType.SetHelpText,
            helpText: { id: getHelpTextId(fieldId), text: error }
        });
    };
    const commonFieldProps = (key) => (Object.assign(Object.assign({}, props), { id: fieldId, fieldKey: key, name, className: getFieldClassName(b, name), autoCompleteType: AutoCompleteType.Off, displayText, error: validationResult.validationErrors[key], setHelpText: handleSetHelpText, showLabel: config.showFieldLabels, disabled, validate: newValue => validator.validateField(key, newValue) }));
    const skeleton = enableSkeletonLoadingIndicators ? (_jsx(FieldSkeleton, { showLabel: false, className: getFieldClassName(b, name) })) : null;
    switch (name) {
        case TicketRedemptionCodeFormFieldName.Code: {
            const key = 'code';
            if (loading)
                return skeleton;
            return (_jsx(InputField, Object.assign({}, commonFieldProps(key), { value: formData[key], validationConfig: validationConfig[key], name: "ticketCodeSearch" // Include 'search' in the name to prevent Safari autofilling with a credit card if the placeholder has 'card number': https://bytes.grubhub.com/b83137b5b1c7
                , type: "text", onChangeValue: newValue => onChange(key, newValue) })));
        }
        case TicketRedemptionCodeFormFieldName.Type: {
            const key = 'typeId';
            return _jsx(TicketRedemptionCodeFormFieldType, Object.assign({}, commonFieldProps(key), { skeleton: skeleton }));
        }
        case TicketRedemptionCodeFormFieldName.Pin: {
            const key = 'pin';
            return _jsx(TicketRedemptionCodeFormFieldPin, Object.assign({}, commonFieldProps(key), { skeleton: skeleton }));
        }
        default:
            throw new InvalidFieldNameError('TicketRedemptionCodeFormField', name);
    }
});
TicketRedemptionCodeFormField.displayName = 'TicketRedemptionCodeFormField';
export const TicketRedemptionCodeFormFieldComponent = withComponentWrapper(TicketRedemptionCodeFormField, defaultTicketRedemptionCodeFormFieldPropsProvider, ticketRedemptionCodeFormFieldPropsValidator);
